import { message, Select, Spin } from 'antd';
import { useState, useEffect, useMemo } from 'react';
import debounce from 'lodash/debounce';
import viewcartApi from '@/service/modules/viewcartApi';

const { Option } = Select;

interface AsyncSelectProps {
  value?: string;
  onChange?: (value: string, option: any) => void;
  placeholder?: string;
  notAutoSelect?: boolean;
}

const SuburbSelect: React.FC<AsyncSelectProps> = ({ value, onChange, placeholder, notAutoSelect }) => {
  const [options, setOptions] = useState<{ suburbID: string | number; description: string; suburbName: string }[]>([]);
  const [loading, setLoading] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (options.find((opt: any) => opt.suburbID == value)) return; // 如果当前值已经在选项中，则不重新获取数据
    value && getSuburbInfo(value);
  }, [value])

  // 仅有一个的时候自动选中
  useEffect(() => {
    if (notAutoSelect) return;
    if (options.length === 1) {
      const onlyOption: any = options[0];
      onChange?.(onlyOption.suburbID, { ...onlyOption, name: onlyOption.suburbName });
      // setDropdownOpen(false);
    }
  }, [options]);


  // 获取接口数据
  const fetchOptions = async (keyword: string) => {
    if (!keyword) {
      setOptions([]);
      return;
    }
    setLoading(true);
    try {
      const response = await viewcartApi.getSuburbList(keyword);
      const data = await response.data.suburbs
      setOptions(data || []);
      // if(data.length == 0) {
      //   message.warning("Invalid Suburb")
      // }
    } catch (error) {
      console.error('Error fetching options:', error);
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  // 防抖，避免频繁请求
  const handleSearch = useMemo(() => {
    return debounce((keyword: string) => {
      fetchOptions(keyword);
    }, 300);
  }, []);

  const getSuburbInfo = async (suburbID: string | number) => {
    try {
      const res = await viewcartApi.getSuburbinfo(suburbID);
      const { suburb } = res.data
      setOptions([suburb]);
    } catch (error) {
      console.log(error);

    }
  }


  useEffect(() => {
    return () => handleSearch.cancel(); // 组件卸载时清除防抖
  }, [handleSearch]);

  return (
    <Select
      showSearch
      value={value}
      inputValue={inputValue}
      open={dropdownOpen}
      onSearch={(val) => {
        setInputValue(val)
        // 输入长度大于等于3时才触发搜索
        if (val.length >= 3) {
          handleSearch(val);
          setDropdownOpen(true);
        }
      }}
      onSelect={(v, option) => {
        onChange?.(v, option);
        setDropdownOpen(false); // 手动选择后也收起
        setInputValue(''); // 选中后清空输入框
        const myDocument: any = window.document;
        myDocument && myDocument.activeElement.blur();
      }}
      filterOption={false} // 禁用本地过滤，完全依赖接口返回
      loading={loading}
      placeholder={placeholder}
      style={{ width: '100%' }}
      onBlur={() => {
        setDropdownOpen(false); // 失焦时收起下拉菜单
        setInputValue('');
      }}
      onFocus={() => {
        // 聚焦时展开下拉菜单
        options.length && setDropdownOpen(true)
        console.log(options);
        
        const selectedOption = options.find((opt:any) => opt.suburbID === value);
        if (selectedOption) {
          setInputValue(selectedOption.suburbName);
        }
      }} 
      suffixIcon={''}
      notFoundContent={loading ? null : null} // 自定义无数据时的内容
    >
      {options.map((opt: any) => (
        <Option key={opt.suburbID} value={opt.suburbID} name={opt.suburbName}>
          <h2>{opt.suburbName}</h2>
          <p style={{ color: '#999', fontSize: 12 }}>{opt.description}</p>
        </Option>
      ))}
    </Select>
  );
};

export default SuburbSelect;
